import BaseAdsNearbyPlaces from './BaseAdsNearbyPlaces';

export default BaseAdsNearbyPlaces;
